import { ThemeToggle } from '@/components/auth/theme-toggle';
import { HyggeLogo } from '@/components/icons/hygge-logo';
import { TooltipProvider } from '@/components/ui/tooltip';

// Header + footer frame for the unauthenticated pages people reach from an
// email link (pre-boarding form, consent confirm) — no sidebar, no session.
export function PublicPageShell({ children }: { children: React.ReactNode }) {
  return (
    <TooltipProvider>
      <div className="min-h-screen bg-background flex flex-col">
        <header className="sticky top-0 z-50 border-b border-border bg-background/85 backdrop-blur-xl">
          <div className="max-w-[1080px] mx-auto px-8 flex items-center justify-between h-[60px]">
            <span className="flex items-center">
              <HyggeLogo className="h-8" />
            </span>
            <ThemeToggle />
          </div>
        </header>
        <main className="flex-1">{children}</main>
        <footer className="text-center py-7 border-t border-border text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} Hygge Software. All rights reserved.
        </footer>
      </div>
    </TooltipProvider>
  );
}
